<template>
  <q-banner inline-actions class="text-white" :class="type === 'error' ? 'bg-red-4' : 'bg-lm-green'" rounded>
    <div class="banner-content">
      <q-icon class="fas" :class="type === 'error' ? 'fa-exclamation-circle' : 'fa-check-circle'" size="1.2rem" />
      <div class="text-subtitle1">{{ message }}</div>
    </div>

    <template #action>
      <slot />
    </template>
  </q-banner>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
      validator: val => ['success', 'error'].includes(val)
    },

    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.banner-content {
  display grid
  grid-template-columns auto 1fr
  align-items center
  gap 10px
}
</style>
